import { createAction, props } from '@ngrx/store';

export const loadLegalEntitiesHierarchy = createAction(
  '[LegalEntities] Load LegalEntitiesHierarchy',
  props<{ request: { BusinessId: string; SearchParam: string } }>()
);

export const loadLegalEntitiesHierarchySuccess = createAction(
  '[LegalEntities] Load LegalEntitiesHierarchy Success',
  props<{ response: any }>()
);

export const loadLegalEntitiesHierarchyFailure = createAction(
  '[LegalEntities] Load LegalEntitiesHierarchy Failure',
  props<{ error: Error | any }>()
);

export const clearLegalEntitiesHierarchy = createAction('[LegalEntities] Clear LegalEntitiesHierarchy');

export const clearLegalEntitiySelected = createAction('[LegalEntities] clear LegalEntitiesLists ');

export const saveSelectedLegalEntitiyId = createAction('[LegalEntities] save businessId', props<{ save: string }>());
